export const UNSPECIFIED_DOWNTIME_REASON_KEY = "__UNSPECIFIED__";
export const UNSPECIFIED_DOWNTIME_REASON_LABEL = "Neden belirtilmemiş";

function cleanReason(value: string | null | undefined) {
  return value?.trim().replace(/\s+/gu, " ") ?? "";
}

/**
 * Keeps report grouping deterministic without claiming that similar free text
 * has the same operational meaning. Turkish case conversion makes only casing
 * and accidental surrounding/inter-word whitespace equivalent.
 */
export function downtimeReasonIdentity(value: string | null | undefined) {
  const label = cleanReason(value);
  if (!label) {
    return {
      key: UNSPECIFIED_DOWNTIME_REASON_KEY,
      label: UNSPECIFIED_DOWNTIME_REASON_LABEL,
    } as const;
  }
  return {
    key: label.toLocaleLowerCase("tr-TR"),
    label,
  } as const;
}
